export default __webpack_public_path__ + "static/media/e-commerece.2bf65240.jpeg";